import React from "react";
import { RentLandingScreenContainer } from "src/containers";

export const RentLandingScreen = () => {
  return <RentLandingScreenContainer />;
};
